import { render, staticRenderFns } from "./tdTimeSubstring.vue?vue&type=template&id=06a55ef4&scoped=true&"
import script from "./tdTimeSubstring.vue?vue&type=script&lang=js&"
export * from "./tdTimeSubstring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a55ef4",
  null
  
)

export default component.exports